import React from 'react'
import { Field } from 'formik'
import { Label, Text } from '../../../ui/Typography.js'
import { ColorPickerRow } from '../../../ui/ColorPicker.js'
import { SideSelect } from '../../../ui/Select.js'
import ToggleRedGreen from '../../../ui/ToggleRedGreen.js'
import CollapsibleSection from '../../../Components/CollapsibleSection.js'
import { Flex } from '../../../ui/Layout.js'
import formikFormWrapper from '../../../formikFormWrapper.js'
import { SideInput } from '../../../ui/Input.js'

const FormSideInput = formikFormWrapper(SideInput)

const ButtonsSection = ({ values, setFieldValue, openCollapsible, setOpenCollapsible }) => {
  if (values.isNavigationCampaign) return null

  return (
    <CollapsibleSection
      topBorder
      label="Buttons"
      openCollapsible={openCollapsible}
      setOpenCollapsible={setOpenCollapsible}
      icon="hand-pointing-white"
      iconBgColor="black"
      noContentPadding
    >
      <Flex borderTop="1px solid rgba(237, 242, 247, 1)" pt="16px">
        <ColorPickerRow
          isBottom
          label="Button Color"
          setFieldValue={setFieldValue}
          name="buttonColor"
          value={values.buttonColor}
        />
      </Flex>
      <Flex flexDirection="column" borderBottom="1px solid rgba(237, 242, 247, 1)">
        <ColorPickerRow
          isBottom
          label="Font Color"
          setFieldValue={setFieldValue}
          name="buttonFontColor"
          value={values.buttonFontColor}
        />
        <Field
          tooltip="Font family may not display correctly in preview.<br>No value will attempt to inherit your websites default font."
          name="fontFamily"
          label="Font Family"
          dark
          component={FormSideInput}
        />
        <Text px="24px" mb="16px" mt="-16px" textAlign="right" fontSize="12px" lightLight underline>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://clipara.notion.site/Customising-Buttons-CTAs-6d693e3fcd2042b0939c798f681e0d77"
          >
            How to find your font family
          </a>
        </Text>
      </Flex>
      <Flex borderBottom="1px solid rgba(237, 242, 247, 1)" pt="16px">
        <Field
          name="buttonOpacity"
          label="Opacity"
          textPostFix="%"
          type="number"
          placeholder="100%"
          min="0"
          max="100"
          dark
          component={FormSideInput}
        />
      </Flex>

      <Flex flexDirection="column" borderBottom="1px solid rgba(237, 242, 247, 1)" pt="16px">
        {!values.isDownloadCampaign && (
          <ColorPickerRow
            label="Button Border"
            setFieldValue={setFieldValue}
            name="buttonBorderColor"
            value={values.buttonBorderColor}
          />
        )}
        <Field
          name="buttonBorderRadius"
          label="Round Corners"
          textPostFix="px"
          type="number"
          min="0"
          max="50"
          dark
          component={FormSideInput}
        />
      </Flex>

      {!values.isShoppable && (
        <>
          <SideSelect
            label="Button width"
            width="100%"
            value={values.buttonFullWidth}
            onChange={(option) => setFieldValue('buttonFullWidth', option.value)}
            options={[
              { value: true, label: 'Full width' },
              { value: false, label: 'Hug content' }
            ]}
            placeholder="Select option"
          />
          <Flex my="24px" px="24px" justifyContent="space-between" alignItems="center">
            <Label mb="0px">Open links in new tab:</Label>
            <ToggleRedGreen
              setSelected={(selected) => {
                setFieldValue('openButtonLinksNewTab', selected)
              }}
              value1={false}
              value2={true}
              selected={values.openButtonLinksNewTab}
            />
          </Flex>
        </>
      )}
    </CollapsibleSection>
  )
}

export default ButtonsSection
